<template>
  <div id="pagination">
    <div>
      <el-pagination
        background
        :layout="layout"
        @current-change="changePage"
        @size-change="sizeShange"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        :current-page="currentPage"
        :total="total"
        >
        <!-- <span class="el-pagination__total">第{{currentPage}}/{{Math.ceil(total/pageSize)}}页</span> -->
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    pageSizes:{
        type:Array,
        default:()=>{
            return [];
        }
    },
    pageSize:{
      type:Number,
      default:10,
    },
    currentPage:{
      type:Number,
      default:1,
    },
    total:{
      type:Number,
      default:0,
    },
    layout:{
      type:String,
      default:'->,total,slot,prev, pager, next,sizes,jumper',
    },
  },
  data(){
    return{

    }
  },
  methods:{
    changePage(val){
      this.$emit("current-change",val);
    },
    sizeShange(val){
      this.$emit("size-change",val);
    }
  }
}
</script>
<style lang="less" scoped>
#pagination{
  /deep/ .el-pagination__rightwrapper{
    text-align: center;
    float:none;
  }
  /deep/.el-input__inner {
      color: @defalutColor;
  }
  /deep/.el-pagination.is-background .btn-next,/deep/.el-pagination.is-background .btn-prev{
      margin: 0 4px;
      background-color: white;
      color: #999;
      border:1px solid rgba(210,210,210,1);
      border-radius:4px;
  }

  /deep/.el-pagination__editor.el-input .el-input__inner {
      border:1px solid rgba(210,210,210,1);
      width: 40px;
      border-radius:4px;
      padding: 0 6px;
  }

  /deep/.el-pagination .el-pager li {
      color: @defalutColor;
      font-weight: 400;
      font-size: 14px;
      background: white;
      border:0.5px solid rgba(210,210,210,1);
      margin: 0 4px;
  }

  /deep/.el-pagination .el-pager li:hover{
      color: @themeColor;
  }

  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    // background-color: @themeColor;
    background-color: @themeColor;
    color: #fff;
    border:0.5px solid @themeColor;
  }

  /deep/.el-pagination__total {
      color: @defalutColor;
      font-size: 12px;
  }

  /deep/.el-pagination__jump {
      color: @defalutColor;
      font-size: 12px;
  }
}
</style>
